import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translate } from '@material-ui/icons';
import axiosUI from '../../../axiosUI';
import cx from 'classnames';
import Autosuggest from 'react-autosuggest';
import { motion, AnimatePresence } from 'framer-motion';
import { withGlobalContext } from '../../../App';
import { NODES, NOTIFICATIONS, RESOURCE_STATES } from '../../../constants';
import PopupWrapper from '../../PopupWrapper';
const { PUBLISHED } = RESOURCE_STATES;

class Translations extends Component {
  static propTypes = {
    editor: PropTypes.object,
    value: PropTypes.object,
    locale: PropTypes.string,
    sales_channel: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
      suggestions: [],
      translationSuggestionValue: '',
      translations: {},
    };

    this.getSuggestions = this.getSuggestions.bind(this);
    this.getSuggestionValue = this.getSuggestionValue.bind(this);
    this.renderSuggestion = this.renderSuggestion.bind(this);
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(
      this
    );
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(
      this
    );
    this.onTranslationSuggestionChange = this.onTranslationSuggestionChange.bind(
      this
    );
    this.togglePopup = this.togglePopup.bind(this);
    this.insertTranslation = this.insertTranslation.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
  }

  getSuggestions(value) {
    const { locale, sales_channel } = this.props;
    const market = `${sales_channel}_${locale}`;
    const marketTranslations = this.state.translations[market];
    if (marketTranslations) {
      const inputValue = value.trim().toLowerCase();
      const inputLength = inputValue.length;

      if (!inputLength) {
        return [];
      }

      const matches = marketTranslations.filter(article => {
        return article.title.toLowerCase().includes(inputValue);
      });

      const slicedMatches = matches.slice(0, 10);
      return slicedMatches;
    }

    return [];
  }

  getSuggestionValue(suggestion) {
    return suggestion.title;
  }

  renderSuggestion(suggestion) {
    return <div>{suggestion.title}</div>;
  }

  onSuggestionsFetchRequested({ value }) {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  }

  onSuggestionsClearRequested() {
    this.setState({ suggestions: [] });
  }

  onTranslationSuggestionChange(event, { newValue }) {
    this.setState({ translationSuggestionValue: newValue });
  }

  togglePopup = async () => {
    const { locale, sales_channel } = this.props;

    // block popup open if locale or sales_channel is missing
    if (!this.state.showPopup) {
      if (!locale || !sales_channel) {
        return this.props.createNotification({
          message: `Please select a market to use translations`,
          type: NOTIFICATIONS.TYPE.INFO,
          timeout: 3000,
        });
      }

      await this.fetchAndSetMarketTranslationsOnState(sales_channel, locale);
    }

    this.setState(prevState => ({ showPopup: !prevState.showPopup }));
  };

  fetchAndSetMarketTranslationsOnState = async (sales_channel, locale) => {
    const market = `${sales_channel}_${locale}`;
    const translationsArePresentInState = this.state.translations[market];
    if (!translationsArePresentInState) {
      try {
        const url = `/api/translations`;
        const { data } = await axiosUI(url, {
          params: {
            locale,
            salesChannel: sales_channel,
          },
        });

        const publishedTranslations = data.filter(t => t.state === PUBLISHED);
        const selectOptions = publishedTranslations.map(t => {
          return { title: t.name, value: t.content };
        });

        this.setState({
          translations: {
            ...this.state.translations,
            [market]: selectOptions,
          },
        });
      } catch (err) {
        console.log(err);
      }
    }
  };

  insertTranslation(event) {
    event.preventDefault();

    this.props.editor.insertInline({
      type: NODES.TRANSLATION,
      data: { translationKey: this.state.translationSuggestionValue },
      isVoid: true,
    });

    this.togglePopup();
    this.setState({ suggestions: [], translationSuggestionValue: '' });
  }

  onSuggestionSelected(event) {
    // adding this to avoid auto close of popups
    event.stopPropagation();
  }

  render() {
    const autoSuggestInputProps = {
      placeholder: 'Enter translation key to search',
      value: this.state.translationSuggestionValue,
      onChange: this.onTranslationSuggestionChange,
      className: 'link__input normal-border-sm w-48 rounded-sm p-1',
    };
    const disableSubmitButton = !this.state.translationSuggestionValue.trim();
    return (
      <PopupWrapper
        isOpen={this.state.showPopup}
        togglePopup={this.togglePopup}>
        <span className="icon__wrapper icon__wrapper--snippet">
          <button
            title="Snippet"
            className={cx('icon__button', {
              active: this.state.showPopup,
            })}
            onClick={this.togglePopup}>
            <Translate />
          </button>
          <AnimatePresence>
            {this.state.showPopup && (
              <motion.div
                initial={{ opacity: 0, y: '80%' }}
                animate={{ opacity: 1, y: '100%' }}
                exit={{ opacity: 0, y: '80%' }}
                transition={{ ease: [0.18, 0.89, 0.39, 1.4], duration: 0.3 }}
                className="icon__popup icon__popup--snippet icon__popup--with_autosuggest">
                <label className="text-sm font-bold flex just-between items-center whitespace-no-wrap mb-5">
                  Translation
                  <Autosuggest
                    alwaysRenderSuggestions
                    suggestions={this.state.suggestions}
                    onSuggestionsFetchRequested={
                      this.onSuggestionsFetchRequested
                    }
                    onSuggestionsClearRequested={
                      this.onSuggestionsClearRequested
                    }
                    getSuggestionValue={this.getSuggestionValue}
                    renderSuggestion={this.renderSuggestion}
                    inputProps={autoSuggestInputProps}
                    onSuggestionSelected={this.onSuggestionSelected}
                  />
                </label>
                <div>
                  <button
                    className={cx(
                      'normal-button rounded p-1 font-bold cursor-pointer w-full',
                      { disable: disableSubmitButton }
                    )}
                    onClick={this.insertTranslation}>
                    Add Translation
                  </button>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </span>
      </PopupWrapper>
    );
  }
}

export default  withGlobalContext(Translations);
